<template>
  <div
    v-show="l_hasContent"
    class="trainer-confirm-btns tracobtns"
  >
    <div
      class="tracobtns_btns tracobtns_btns_on-side tracobtns_btns_on-side_left"
      :class="{ 'tracobtns_btns_on-sides': !btnsOnSide }"
    >
      <div
        v-if="hasForward"
        class="csst gw_btn-r1 tracobtns_arrow gw_btn_text tracobtns_btn_left"
        style="--padding: 0; min-width: 4.25em; min-height: 4.25em"
        :class="[{ 'opacity_3 no-events': backDisabled }]"
        @click="go(-1)"
      >
        <div class="mdi mdi-chevron-left tracobtns_btn_icon ma-0"></div>
      </div>
      <div
        v-if="hasBack"
        class="csst gw_btn-r1 tracobtns_arrow gw_btn_text tracobtns_btn_right"
        style="--padding: 0; min-width: 4.25em; min-height: 4.25em"
        :class="[{ 'opacity_3 no-events': forwardDisabled }]"
        @click="go(1)"
      >
        <div class="mdi mdi-chevron-right tracobtns_btn_icon ma-0"></div>
      </div>
    </div>

    <GwMenu
      v-if="hasMenu"
      class="tracobtns_menu"
    >
      <template #opener>
        <div class="mdi mdi mdi-dots-vertical icon_btn tracobtns_menu_opener_icon" />
      </template>
      <template #default="{ methods }">
        <GwBtns
          :options="menuBtns"
          class="gwbtns_vertical_white gw_menu"
          @click="
            (_e, item) => {
              methods.toggleOpen(false)
              handleClick(item)
            }
          "
        >
          <template #default="{ item }">
            <i
              class="mdi text-normal mr-2"
              :class="item.icon"
            ></i>
            {{ item.text }}
          </template>
        </GwBtns>
      </template>
    </GwMenu>

    <div
      class="tracobtns_btns"
      :class="{
        'tracobtns_btns_on-side tracobtns_btns_on-side_right': btnsOnSide,
      }"
    >
      <div
        v-for="(item, idx) in btns"
        :id="item.id"
        :key="item.id"
        :data-tst="`tracobtns_${item.id}`"
        class="tracobtns_btn text-center"
        :class="[`btn_${idx + 1}_${btns.length}`]"
      >
        <div
          class="text-wrap overflow-hidden"
          :class="[
            btnsOnSide ? 'gw_btn-square' : 'gw_btn-v1 flex-1',
            btns.length - 1 === idx && !item.noPrimary ? 'gw_btn_primary' : item.css_class,
          ]"
          @click="handleClick(item)"
        >
          <div
            class="mdi tracobtns_btn_icon"
            :class="item.icon"
          ></div>
          <div>
            {{ btnsOnSide ? item.text_abbr || item.text : item.text }}
          </div>
          <slot :name="item.slot || 'unset'" />
        </div>
      </div>
      <TrainerResultChartSwitcherMenu
        v-if="hasResultSwitcher"
        class="tracobtns_resultviewswitch"
        style="--opener-size: 1.25rem"
        menuPosition="top-end"
        tooltipPosition="top-end"
        :iconOpener="btnsOnSide ? 'mdi-dots-horizontal' : 'mdi-dots-vertical'"
        :visibleOptions="['fh_trainer_game_speed']"
      />
      <TrainerPreferencesMenu
        v-if="hasPreferencesMenu"
        tooltipStrategy="absolute"
        class="tracobtns_preferencesmenu"
        style="--opener-size: 1.25rem"
        :namespace="'tra/alpha'"
        menuPosition="top-end"
        tooltipPosition="top-end"
        :iconOpener="btnsOnSide ? 'mdi-dots-horizontal' : 'mdi-dots-vertical'"
        :visibleOptions="['fh_trainer_game_speed']"
      />
    </div>

    <slot />
  </div>
</template>

<script>
import { nextTick } from 'vue'
import GwMenu from '@/components/lib/GwMenu'
import GwBtns from '@/components/lib/GwBtns'
import links_mix from '@/mixins/links_mix'
import TrainerResultChartSwitcherMenu from '@/components/Trainer/TrainerResultChartSwitcherMenu'
import TrainerPreferencesMenu from '@/components/Trainer/TrainerPreferencesMenu'

export default {
  name: 'TrainerConfirmBtns',
  components: {
    // TrainerResultChartSwitcher,
    TrainerResultChartSwitcherMenu,
    TrainerPreferencesMenu,
    GwMenu,
    GwBtns,
  },
  mixins: [links_mix],
  props: {
    btnsOnSide: Boolean,
    hasChangeMove: Boolean,
    hasContinue: Boolean,
    hasConfirmSlider: Boolean,
    hasReturnToGame: Boolean,
    hasPlayAsHero: Boolean,
    hasChangeBotAction: Boolean,
    hasNewHand: Boolean,
    hasStopNewHand: Boolean,
    hasRepeatHand: Boolean,
    showdown: Boolean,
    hasForward: Boolean,
    hasBack: Boolean,
    forwardDisabled: Boolean,
    backDisabled: Boolean,
    hasMenu: Boolean,
    active: Boolean,
    hasStopHands: Boolean,
    hasCloseSession: Boolean,
    hasRestartHands: Boolean,

    hasNewHandSecondary: Boolean,
    hasRepeatHandPrimary: Boolean,
    hasResultSwitcher: Boolean,
    hasPreferencesMenu: Boolean,
  },
  emits: [
    'go', //
    'continue',
    'changeMove',
    'confirmSlider',
    'changeBotAction',
    'playAsHero',
    'closeSession',
    'stopHands',
    'restartHands',
    'returnToGame',
    'repeatHand',
    'newHand',
    'repeatHand',
    'stopNewHand',
  ],
  methods: {
    go(num) {
      if (!this.forwardDisabled && num === 1) {
        this.$emit('go', num)
      } else if (!this.backDisabled && num === -1) {
        this.$emit('go', num)
      }
      // }
    },
    handleClick(item) {
      if (item.fn) {
        item.fn()
      }
      this.$emit(item.id)
    },
  },
  computed: {
    allBtns() {
      const res = [
        {
          ifProp: 'hasChangeMove',
          id: 'changeMove',
          icon: 'mdi-swap-horizontal',
          css_class: 'gw_btn_text',
          text: this.$t('btn.change_move'),
          text_abbr: this.$t('btn.change_move_abbr'),
        },
        {
          ifProp: 'hasContinue',
          id: 'continue',
          icon: 'mdi-chevron-double-right',
          css_class: 'gw_btn_text',
          text: !this.showdown
            ? this.$t('practice.table.continue')
            : this.$t('practice.table.showdown'),
        },
        {
          ifProp: 'hasConfirmSlider',
          id: 'confirmSlider',
          css_class: 'gw_btn_primary',
          icon: 'mdi-chevron-double-right',
          text: this.$t('btn.confirm'),
        },
        {
          ifProp: 'hasChangeBotAction',
          id: 'changeBotAction',
          css_class: 'gw_btn_text',
          icon: 'mdi-swap-horizontal',
          text: this.$t('btn.change_move'),
          text_abbr: this.$t('btn.change_move_abbr'),
        },
        {
          ifProp: 'hasPlayAsHero',
          id: 'playAsHero',
          css_class: 'gw_btn_text',
          icon: 'mdi-crown',
          text: this.$t('btn.play_as_hero'),
          text_abbr: this.$t('btn.play_as_hero_abbr'),
        },

        {
          ifProp: 'hasCloseSession',
          id: 'closeSession',
          css_class: 'gw_btn_text',
          icon: 'mdi-stop',
          text: this.$t('common.close_session'),
        },
        {
          ifProp: 'hasStopHands',
          id: 'stopHands',
          noPrimary: true,
          css_class: 'gw_btn_text',
          icon: 'mdi-stop',
          text: this.$t('common.stop_session'),
        },
        {
          ifProp: 'hasRestartHands',
          id: 'restartHands',
          css_class: 'gw_btn_primary',
          icon: 'mdi-play',
          text: this.$t('common.restart_session'),
        },
        {
          ifProp: 'hasReturnToGame',
          id: 'returnToGame',
          css_class: 'gw_btn_text',
          icon: 'mdi-play',
          text: this.$t('btn.play_from_here'),
          text_abbr: this.$t('btn.play_from_here_abbr'),
        },
        {
          ifProp: 'hasRepeatHand',
          id: 'repeatHand',
          css_class: 'gw_btn_text',
          icon: 'mdi-reload',
          text: this.$t('btn.repeat_hand'),
          text_abbr: this.$t('btn.repeat_hand_abbr'),
        },
        {
          ifProp: 'hasNewHand',
          id: 'newHand',
          css_class: 'gw_btn_primary',
          icon: 'mdi-fast-forward',
          text: this.$t('btn.next_hand'),
          text_abbr: this.$t('btn.next_hand_abbr'),
        },

        // duplicated  - TODO revrite this to arrays of props
        {
          ifProp: 'hasNewHandSecondary',
          id: 'newHand',
          uid: 'replay_newHand',
          css_class: 'gw_btn_text',
          icon: 'mdi-fast-forward',
          text: this.$t('btn.next_hand'),
          text_abbr: this.$t('btn.next_hand_abbr'),
        },
        {
          ifProp: 'hasRepeatHandPrimary',
          id: 'repeatHand',
          uid: 'replay_repeatHand',
          css_class: 'gw_btn_primary',
          icon: 'mdi-reload',
          text: this.$t('btn.repeat_hand'),
          text_abbr: this.$t('btn.repeat_hand_abbr'),
        },
        // ------

        {
          ifProp: 'hasStopNewHand',
          id: 'stopNewHand',
          css_class: 'gw_btn_primary',
          slot: 'progress-line',
          icon: 'mdi-stop',
          text: this.$t('btn.stop_next_hand'),
          text_abbr: this.$t('btn.stop_next_hand_abbr'),
        },
      ]

      return res
    },
    btns() {
      const res = this.allBtns.filter(item => this[item.ifProp])
      return res
    },
    menuBtns() {
      const ids = [
        'stopHands', //
        'replay_newHand',
        'replay_repeatHand',
        'openSettings',
        // 'studySpot',
      ]
      const res = this.allBtns.filter(item => ids.includes(item.uid || item.id))
      return res
    },
    l_hasContent() {
      const res = this.btns.length || this.hasForward || this.hasBack
      return res
    },
    hotkeysPressedBottom() {
      return this.$store.getters.hotkeys_pressed_bottom
    },
  },
  watch: {
    hotkeysPressedBottom(keys) {
      if (!this.active) return
      if (!keys) return
      const hotkeyActions = {
        ...(this.hasContinue
          ? {
              cbtns_continue: {
                keys: ['enter'],
                fn: () => this.$emit('continue'),
                hasPreventDefault: true,
              },
            }
          : {}),
        ...(this.hasConfirmSlider
          ? {
              cbtns_confirmSlider: {
                keys: ['enter'],
                fn: () => this.$emit('confirmSlider'),
                hasPreventDefault: true,
              },
            }
          : {}),
        ...(this.hasNewHand
          ? {
              cbtns_newHand: {
                keys: ['enter'],
                fn: () => this.$emit('newHand'),
                hasPreventDefault: true,
              },
            }
          : {}),
        ...(this.hasChangeMove
          ? {
              cbtns_changeMove: {
                keys: ['escape'],
                fn: () => this.$emit('changeMove'),
                hasPreventDefault: true,
              },
            }
          : {}),

        ...(this.hasStopNewHand
          ? {
              cbtns_stopNewHand: {
                keys: ['enter'],
                fn: () => this.$emit('stopNewHand'),
                hasPreventDefault: true,
              },
            }
          : {}),
        ...(this.hasStopNewHand
          ? {
              cbtns_stopNewHand2: {
                keys: ['escape'],
                fn: () => this.$emit('stopNewHand'),
                hasPreventDefault: true,
              },
            }
          : {}),

        ...(!this.forwardDisabled
          ? {
              cbtns_forward: {
                keys: ['arrowright'],
                fn: () => this.go(1),
                hasPreventDefault: true,
              },
            }
          : {}),
        ...(!this.backDisabled
          ? { cbtns_back: { keys: ['arrowleft'], fn: () => this.go(-1), hasPreventDefault: true } }
          : {}),
      }
      // console.log(keys, hotkeyActions)
      this.$store.dispatch('hotkeys_perform_action', { keys, hotkeyActions })
    },
  },
}
</script>
<style lang="scss" scoped>
.tracobtns {
  width: 100%;
  max-width: 100vw;
  display: flex;
  align-items: center;
  justify-content: center;
  grid-gap: 0.5em;
  --side-position: 1.75em;
  --side-btn-top: 2em;
  --side-btn-bottom: 6.25em;
  --size: 6em;
  &_btns {
    display: flex;
    align-items: center;
    justify-content: center;
    flex: 1;
    grid-gap: 0.5em;

    &_on-side {
      // flex-direction: column-reverse;
      flex-direction: column;
      align-items: unset;
      justify-content: flex-start;
      position: absolute;
      min-width: var(--size);
      min-height: var(--size);
      top: var(--side-btn-top);
      grid-gap: 0.25em;
      // outline: solid;
      &_left {
        right: calc(100% + var(--side-position));
      }
      &_right {
        left: calc(100% + var(--side-position));
      }
      .tracobtns_btn {
        flex: 1;
        display: block;
        align-items: unset;
        &_icon {
          margin: 0 0 0.125rem 0;
        }
      }
      .tracobtns_resultviewswitch {
        order: 3;
        margin: auto;
      }
      .tracobtns_preferencesmenu {
        order: 3;
        margin: auto;
      }
    }
    &_on-sides {
      position: static;
      display: block;
      flex: 0;
      // max-height: 0px;
      // max-width: 0px;
      min-width: 0px;
      min-height: 0px;
      .tracobtns_btn_left,
      .tracobtns_btn_right {
        position: absolute;
        top: var(--side-btn-top);
        min-width: var(--size);
      }
      .tracobtns_btn_left {
        right: calc(100% + var(--side-position));
      }
      .tracobtns_btn_right {
        left: calc(100% + var(--side-position));
      }
    }
  }
  &_btn {
    max-width: 14em;
    flex: 1;
    display: flex;
    align-items: center;
    justify-content: center;
    position: relative;
    border-radius: 4px;
    overflow: hidden;
    &_icon {
      margin: 0 0.2em 0 0;
      font-size: 1.75em;
      line-height: 1;
      position: relative;
    }
    &_tooltip {
      top: -2em;
      white-space: nowrap;
    }
    &_as-icon {
      flex: unset;
      max-width: unset;
      .tracobtns_btn_icon {
        margin: 0 0 0 -0.2em;
        padding: 0 0.7em;
      }
    }
  }
  &_menu {
    position: relative;
    // background: red;
    &_opener {
      display: flex;
      align-items: center;
      justify-content: center;
      border-radius: 4px;
      // background: var(--clr-black-2);
      &_icon {
        // background: red;
        font-size: 1.75rem;
        height: 36px;
        width: 36px;
        // padding: 0.12em;
        color: var(--clr-grey-2);
      }
    }
    &_content {
      position: absolute;
      overflow: hidden;
      height: 0;
      opacity: 0;
      transform: translate(0, -100%);
      top: -0.2rem;
      left: 0;
      // right: 0;
      background: var(--clr-black-1);
      padding: 0rem 0;
      border-radius: 8px;
      box-shadow: var(--menu-shadow);
      padding: 0.5rem 0;
    }
    &_open {
      .tracobtns_menu_content {
        opacity: 1;
        height: auto;
        transition: 0.22s;
      }
    }
    &_item {
      display: flex;
      align-items: center;
      white-space: nowrap;
      height: 2.2rem;
      --clr-hover: var(--clr-primary);
      color: var(--clr-white-0);
      cursor: pointer;
      display: flex;
      align-items: center;
      background: transparent;
      justify-content: left;
      padding: 0 1rem 0 0.7rem;
      grid-gap: 0.7rem;
      border-radius: 4px;
      font-size: 0.87rem;
      font-weight: 500;
      &_icon {
        line-height: 1rem;
        font-size: 1.5rem;
        width: 1rem;
        margin: 0 0.75rem 0 0;
      }
      &:hover {
        background: var(--clr-black-3);
      }
    }
  }
}
@media (max-width: 1600px) {
  .tracobtns {
    --side-position: 0.75em;
  }
}
@media (max-width: 1400px) {
  .tracobtns {
    // border: solid blue;
    --side-position: 0.5em;
  }
}
// @media (max-width: 1024px) {
//   .tracobtns {
//     --side-position: 0.5em;
//   }
// }
@media (max-width: 1023px) {
  .tracobtns {
    &_btn {
      max-width: unset;
    }
  }
}
</style>
